

// ALLERGIES Getby Id
const ALLERGIES_REQUEST_GETBYID = 'ALLERGIES_REQUEST_GETBYID';
const ALLERGIES_SUCCESS_GETBYID = 'ALLERGIES_SUCCESS_GETBYID';
const ALLERGIES_FAILURE_GETBYID = 'ALLERGIES_FAILURE_GETBYID';

// ALLERGIES Getby Id ALL
const ALLERGIES_REQUEST_GETBYALL_ID = 'ALLERGIES_REQUEST_GETBYALL_ID';
const ALLERGIES_SUCCESS_GETBYALL_ID = 'ALLERGIES_SUCCESS_GETBYALL_ID';
const ALLERGIES_FAILURE_GETBYALL_ID = 'ALLERGIES_FAILURE_GETBYALL_ID';

//ALLERGIESUpdate
const ALLERGIES_REQUEST_UPDATE = 'ALLERGIES_REQUEST_UPDATE';
const ALLERGIES_SUCCESS_UPDATE = 'ALLERGIES_SUCCESS_UPDATE';
const ALLERGIES_FAILURE_UPDATE = 'ALLERGIES_FAILURE_UPDATE';

//ALLERGIESADD
const ALLERGIES_REQUEST_ADD = 'ALLERGIES_REQUEST_ADD';
const ALLERGIES_SUCCESS_ADD = 'ALLERGIES_SUCCESS_ADD';
const ALLERGIES_FAILURE_ADD = 'ALLERGIES_FAILURE_ADD';

//ALLERGIESDELETE

const ALLERGIES_REQUEST_DELETE = 'ALLERGIES_REQUEST_DELETE';
const ALLERGIES_SUCCESS_DELETE = 'ALLERGIES_SUCCESS_DELETE';
const ALLERGIES_FAILURE_DELETE = 'ALLERGIES_FAILURE_DELETE';

export {
    ALLERGIES_REQUEST_GETBYID, ALLERGIES_SUCCESS_GETBYID, ALLERGIES_FAILURE_GETBYID,
    ALLERGIES_REQUEST_UPDATE, ALLERGIES_SUCCESS_UPDATE, ALLERGIES_FAILURE_UPDATE,
    ALLERGIES_REQUEST_ADD, ALLERGIES_SUCCESS_ADD, ALLERGIES_FAILURE_ADD,
    ALLERGIES_REQUEST_DELETE, ALLERGIES_SUCCESS_DELETE, ALLERGIES_FAILURE_DELETE,
    ALLERGIES_REQUEST_GETBYALL_ID, ALLERGIES_SUCCESS_GETBYALL_ID, ALLERGIES_FAILURE_GETBYALL_ID,
    // ALLERGIES_PREV_ID
};